import env from "../../app/config/envHelper";

export const googleMapsLibraries = ["places", "marker"];

export const googleMapsApiKey = env.REACT_APP_GOOGLE_API_KEY;